function getColumns(records) {
  const res = [{ colIndex: 0, width: 220 }];
  let colNum = 1;
  for (const rec of records) {
    res.push({ colIndex: colNum, maxWidth: 90 });
    colNum += 1;
  }
  return res;
}

function getRows(records) {
  let rowIdx = 0;
  const rows = [];
  // Months
  rows.push({
    rowIndex: rowIdx,
    height: 36,
  });
  for (const rec of records) {
    rowIdx += 1;
    // Days
    rows.push({
      rowIndex: rowIdx,
      height: 36,
    });
    rowIdx += 1;
    // Status
    rows.push({
      rowIndex: rowIdx,
      height: 36,
    });
    rowIdx += 1;
    for (const p in rec.prices) {
      rows.push({
        rowIndex: rowIdx,
        height: 36,
      });
      rowIdx += 1;
    }
    rows.push({
      rowIndex: rowIdx,
      height: 10,
    });
  }
  return rows;
}

export { getColumns, getRows };
